<script setup lang="ts">
import { ref } from 'vue'
import { settings } from '@/content'
defineProps<{ title?: string }>()

// Facade "click-to-load" : l'iframe Matterport (et son cookie tiers Cloudflare
// __cf_bm) n'est chargee qu'apres action de l'utilisateur. Rien n'est requis
// aupres de my.matterport.com tant qu'on n'a pas clique : cela supprime le cookie
// tiers au chargement (Best Practices) et allege la page.
const loaded = ref(false)
</script>

<template>
  <section class="section section--alt mtp">
    <div class="container">
      <span class="eyebrow">Visite immersive</span>
      <h2>{{ title || 'Découvrez notre showroom en 3D' }}</h2>
      <div class="mtp__frame">
        <iframe
          v-if="loaded"
          :src="`https://my.matterport.com/show/?m=${settings.matterport_id}&play=1`"
          title="Visite 3D du showroom des Ateliers du Terras"
          allow="fullscreen; vr"
          allowfullscreen
        ></iframe>
        <button
          v-else
          type="button"
          class="mtp__facade"
          aria-label="Lancer la visite 3D du showroom"
          @click="loaded = true"
        >
          <span class="mtp__play" aria-hidden="true">
            <svg viewBox="0 0 24 24" width="34" height="34" fill="currentColor">
              <path d="M8 5v14l11-7z" />
            </svg>
          </span>
          <span class="mtp__label">Lancer la visite 3D</span>
        </button>
      </div>
    </div>
  </section>
</template>

<style scoped>
.mtp__frame {
  margin-top: 20px;
  position: relative;
  aspect-ratio: 16 / 9;
  border-radius: var(--radius);
  overflow: hidden;
  box-shadow: var(--shadow);
}
.mtp__frame iframe {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  border: 0;
}
.mtp__facade {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  border: 0;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  background: radial-gradient(circle at 50% 40%, #33382f 0%, #272a23 70%);
  color: #f0f2ea;
  font-family: var(--font-title);
  transition: background 0.2s;
}
.mtp__facade:hover {
  background: radial-gradient(circle at 50% 40%, #3a4034 0%, #272a23 70%);
}
.mtp__play {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 76px;
  height: 76px;
  border-radius: 50%;
  background: var(--green);
  color: #272a23;
  box-shadow: var(--shadow);
  transition: transform 0.2s;
  padding-left: 4px;
}
.mtp__facade:hover .mtp__play {
  transform: scale(1.06);
}
.mtp__label {
  font-weight: 700;
  font-size: 1rem;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}
</style>
